module.exports = __webpack_public_path__ + "img/gallery14.3b5abd0d.png";